// packages/allma-admin-shell/src/features/prompts/constants.ts
export const PROMPT_TEMPLATES_QUERY_KEY = 'promptTemplates';
export const PROMPT_TEMPLATE_DETAIL_QUERY_KEY = 'promptTemplateDetail';